<template>
  <v-row align-center justify-center row wrap>
    <v-col>
      <img src="/images/svgs/crying-emoji.svg" alt="" srcset="" />
    </v-col>
    <v-col>
      <v-card class="pa-4 my-4" flat v-if="status">
        <h1 class="display-3 error--text">
          {{ $t('errors.nError', { n: status }) }}
        </h1>
        <h1 class="display-2">{{ $t('errors.' + status) }}</h1>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  computed: {
    status() {
      return this.$route.params.status
    },
  },
}
</script>
